import { render, staticRenderFns } from "./HeldBill.vue?vue&type=template&id=740057f4&scoped=true&"
import script from "./HeldBill.vue?vue&type=script&lang=js&"
export * from "./HeldBill.vue?vue&type=script&lang=js&"
import style0 from "./HeldBill.vue?vue&type=style&index=0&id=740057f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740057f4",
  null
  
)

export default component.exports